angular.module(NgAppName).component('crContact', {
	templateUrl: 'crContact.html',
	bindings: {
		buttonText: '@',
		user: '<',
		companyPhone: '@',
		startingDate: '@',
		nbDays: '@',
		popupName: '@',
		emailUsRpc: '@',
		rpc: '@',
		isMobile: "<",
		customTitle: '@',
		customSubtitle: '@',
		customClass: '@',
		oneColumn: '<',
		trackAction: '@',
		trackLabel: '@',
		trackCategory: '@',
		displayTitle: '<',
		displaySubtitle: '<',
		displayDates: '<',
		displayCallUs: '<',
		displayBuilding: '<',
		buildingSearchRpc: '@',
		placeholderMessage: '@',
		info: '@',
		popup: '@',
		gtag: '@',
		rpcRegisterContact: "@", //rpc-register-contact-submit
		rpcSmartmatch: "@", //rpc-register-contact-submit
		token: '@',
		messageLabel: '@',
		buildingToken: '@'
	},
	controller: ['$timeout', '$interval', '$window', "$cookies", 'PubSub', '$element', 'crResourcesService', function($timeout, $interval, $window, $cookies, PubSub, $element, crResourcesService) {
		var ctrl = this;
		this.showDisclaimer = false;

		this.errorMessages = {
			required: 'This field is required.',
			email: 'Invalid Email.',
			emailExist: 'This email already exists.',
			requiredBuilding: 'Building is required.',
			phoneExist: 'This phone already exists.',
			phoneFormat: 'This phone number is not valid.',
			phoneShort: 'This phone is too short (less than 6 characters).',
			minlength: 'Password can\'t be shorter than 6 characters.',
			maxlength: 'Password can\'t be longer than 64 characters.',
			notFullname: 'Please enter a full name.',
			generic: 'Error, please contact us for further assistance.'
		};

		this.building = {
			building: null,
			buildingLabel: null,
			buildingObj: null
		};

		this.placeholderBuilding = "Building Name or Address";

		this.$onInit = () => {
			this.customClass = this.customClass || 'two-columns';

			this.usrRegisterStatus = false;
			this.usrRegisterMessage = "";
			this.autoUsrToken = null;
			this.smartMatchToken = null;
			this.reloadCounter = null;

			if (this.displayDates) {
				this.dates = [];

				for (let i = 0 ; i < this.nbDays ; i++) {
					let nextDate = moment(this.startingDate).add(i, 'days');
					let dayLabel = nextDate.format('ddd');
					let dayNumber = nextDate.format('DD');
					let month = nextDate.format('MMM');
					let dateFormatted = nextDate.format('YYYY-MM-DD');
					this.dates.push({
						selected: (i === 0 ? true : false),
						dayLabel,
						dayNumber,
						month,
						dateFormatted
					});
				}
			}
		};

		this.selectDate = (date) => {
			this.dates.forEach((d) =>{
				d.selected = false;
			});
			date.selected = true;
		};

		this.submitForm = function() {
			var self = this;
			window.crRecaptcha.execute(function(){ self.submitFormLogic()});
		};

		this.submitCnt = 0;
		this.submitFormLogic = function() {
			var url = this.rpc;
			var postData = this.createData();
			var crDataPromise = crResourcesService.post(url, postData);

			this.isLoading = true;
			ctrl.form.globalErrors = [];
			crDataPromise.then(function(data) {
				if (data['RPCFormReusableContact_FORMSUMMARY'][0].status) {
					window.crRecaptcha.setSuccessState(true);
					ctrl.isLoading = false;
					ctrl.successMessage = data['RPCFormReusableContact_FORMSUMMARY'][0].message;

					// disable exit popups
					var now = new Date(),
						exp = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 5); // set the expiration to 5 days ahead
					$cookies.put('exitPopupShown', 'true', {expires: exp});

					// track
					var category = ctrl.trackCategory || $window.pageType;
					if (category && ctrl.trackAction) {
						// console.log('FormSupport', category, ctrl.trackAction, ctrl.trackLabel);
						_gaq.push(['_trackEvent', category, ctrl.trackAction, ctrl.trackLabel]);
					}

					// track gtag
					if (ctrl.gtag && typeof crGtag !== 'undefined') {
						crGtag.track(ctrl.gtag);
					}

					if (data.RPCFormReusableContact_FORMSUMMARY[0].adWordsCampaign && typeof crGtag !== 'undefined') {
						crGtag.track(data.RPCFormReusableContact_FORMSUMMARY[0].adWordsCampaign.send_to, data.RPCFormReusableContact_FORMSUMMARY[0].adWordsCampaign.value);
					}

					if (typeof data["RPCFormReusableContact_FORMSUMMARY"][0].autoUsrToken !== "undefined") {
						ctrl.autoUsrToken = data["RPCFormReusableContact_FORMSUMMARY"][0].autoUsrToken;
					} else {
						ctrl.autoUsrToken = null;
					}

					if (typeof data["RPCFormReusableContact_FORMSUMMARY"][0].smartMatchToken !== "undefined") {
						ctrl.smartMatchToken = data["RPCFormReusableContact_FORMSUMMARY"][0].smartMatchToken;
					} else {
						ctrl.smartMatchToken = null;
					}

					ctrl.submitCnt++;
					ctrl.emptyMessage = false;
					if (!ctrl.autoUsrToken || !ctrl.rpcRegisterContact) {
						if (!!postData.msg || ctrl.submitCnt >= 3) {
							ctrl.emptyMessage = false;
							if (typeof data["RPCFormReusableContact_FORMSUMMARY"][0].token !== "undefined") {
								ctrl.token =  data["RPCFormReusableContact_FORMSUMMARY"][0].token;
							}
							ctrl.isClosing = true;
							$timeout(function() {
								if (ctrl.isClosing) {
									ctrl.closeTour();
									ctrl.isClosing = false;
								}
							}, 5000);
						} else {
							ctrl.emptyMessage = true;
							ctrl.successMessage = null;
						}
					}
					if (!!ctrl.isMobile && !!ctrl.popupName && ctrl.popupName == 'popup-sell') {
						PubSub.publish('cr-popup-publish-success-message-popup-sell', ctrl.successMessage);
					}
				} else {
					window.crRecaptcha.setSuccessState(false);
					let specificError = false;
					if (data["RPCFormReusableContact_email"]) {
						var error = data["RPCFormReusableContact_email"];
						if (error[0].indexOf("valid") > 0) {
							ctrl.form.email.$setValidity("pattern", false);
						} else {
							// may be another/generic message, but for now it's the same
							ctrl.form.email.$setValidity("pattern", false);
						}
						specificError = true;
					}

					if (data["RPCFormReusableContact_dayphone"]) {
						var error = data["RPCFormReusableContact_dayphone"];
						if (error[0].indexOf("already exist") > 0 || error[0].indexOf("already in use") > 0 ) {
							ctrl.form.phone.$setValidity("phoneExist", false);
						} else if (error[0].indexOf("too short") > 0) { // phone too short
							ctrl.form.phone.$setValidity("phoneShort", false);
						} else { // twilio phone error
							ctrl.form.phone.$setValidity("pattern", false);
						}
						specificError = true;
					}

					if (!specificError) {
						ctrl.form.globalErrors.push(ctrl.errorMessages.generic);
					}
					ctrl.isLoading = false;
				}
			});
		};

		this.createData = function() {
			var data = {};
			data.name = this.user.name;
			data.email = this.user.email;
			data.dayphone = this.user.phone;
			data.msg = this.user.message ? this.user.message : '';
			if (this.displayDates) {
				data.selectedDate = this.dates.filter((d) => d.selected)[0].dateFormatted;
			}
			if (this.user.contact_type) {
				data.contact_type = this.user.contact_type;
			}
			if (this.popup) {
				data.popup = this.popup;
			}
			if (this.building.building) {
				data.building = this.building;
			}

			data.reCaptchaTokens =  window.crRecaptcha.getTokens();
			data.token = this.token;

			return data;
		};

		this.closeTour = function() {
			ctrl.isClosing = false;
			PubSub.publish('cr-popup-close-' + this.popupName);
		};

		this.hideSuccessMessage = function() {
			ctrl.successMessage = null;
			if (!!ctrl.isMobile && !!ctrl.popupName && ctrl.popupName == 'popup-sell') {
				PubSub.publish('cr-popup-publish-success-message-popup-sell', ctrl.successMessage);
			}
		};

		this.updateMsg = (data) => {
			this.user.message = (this.user.message ? this.user.message + ' ' : '') + data.buildingName;
		};

		this.closeTheForm = () => {
			this.hideSuccessMessage();
			this.closeTour();
		};

		this.yesEmailTheListings = () => {
			this.isLoading = true;
			this.usrRegisterStatus = false;
			this.usrRegisterMessage = "";
			this.reloadCounter = null;

			var input = {
				autoUsrToken: this.autoUsrToken
			};

			if (this.buildingToken) {
				input.buildingToken = this.buildingToken;
			}

			var crDataPromise = crResourcesService.post(this.rpcRegisterContact, input);
			crDataPromise.then((data) => {
				if (typeof data.status !== "undefined") {
					this.usrRegisterStatus = data.status;
				}
				if (typeof data.message !== "undefined") {
					this.usrRegisterMessage = data.message;
				}
			}).finally(() => {
				this.isLoading = false;
				this.reloadCounter = 5;
				this.decCounter();
			});
		};

		this.subscribeSmartMatch2 = () => {
			this.isLoading = true;
			this.usrRegisterStatus = true;
			this.usrRegisterMessage = "";
			this.reloadCounter = null;

			var input = {
				smartMatchToken: this.smartMatchToken
			};

			var crDataPromise = crResourcesService.post(this.rpcSmartmatch, input);
			crDataPromise.then((data) => {
				if (this.trackLabelSignedUpSM) {
					crTrackerQueue.track({
						category: this.trackCategory,
						action: this.trackAction,
						label: this.trackLabelSignedUpSM
					});
				}
			}).finally(() => {
				this.isLoading = false;
				this.reloadCounter = 5;
				this.decCounter();
			});
		};

		this.canRegister = () => {
			return this.autoUsrToken && this.rpcRegisterContact;
		};

		this.canDoSmartmatch = () => {
			return this.smartMatchToken && this.rpcSmartmatch;
		};

		this.decCounter = () => {
			var countdown = () => {
				this.reloadCounter--;
				if (this.reloadCounter === 0) {
					this.reloadPage();
				}
			};

			// wait for the sales history to be loaded
			let waitingInterval = $interval(countdown, 1000, 5);
		};

		this.reloadPage = () => {
			$window.location.reload();
		};

		PubSub.subscribe('cr-popup-update-state-' + this.popupName, this.hideSuccessMessage);
		PubSub.subscribe('cr-contact-buyers', this.updateMsg);
	}]
});